import { inject, signal } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

import { ApiErrors } from '@ti/contracts'
import { checkExistApiError, getApiErrorKey, getMessageFromException } from '@ti/core/common/utils'
import { LanguageService } from '@ti/core/ui-kit/i18n'

export abstract class ForgotPasswordViewModel {
  public readonly isLoading = signal(false)
  public readonly isFormOpened = signal(false)
  public readonly isResetRequested = signal(false)
  public readonly apiErrorMessage = signal('')

  protected readonly languageService = inject(LanguageService)
  public readonly form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  })

  public async submitForm() {
    if (!this.form.valid) {
      return this.form.markAllAsTouched()
    }

    const email = this.form.value.email
    if (email && !this.isLoading()) {
      try {
        this.isLoading.set(true)
        this.apiErrorMessage.set('')
        await this.requestPasswordReset(email)
        this.isFormOpened.set(false)
        this.isResetRequested.set(true)
      } catch (error) {
        console.warn(`Cannot reset password`, error)
        const message = getMessageFromException(error)
        this.apiErrorMessage.set(
          await this.languageService.translate(
            checkExistApiError(message)
              ? getApiErrorKey(message)
              : getApiErrorKey(ApiErrors.unknown),
          ),
        )
      } finally {
        this.isLoading.set(false)
      }
    }
  }

  public async closeForm() {
    this.isResetRequested.set(false)
    this.form.reset()
  }

  protected abstract requestPasswordReset(email: string): Promise<void>
}
